import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ReceiveReportListRes;
export const ReceiveReportListTodo = createAsyncThunk('ReceiveReportList', async (data) => {
    console.log("data",data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'datewise_items_list',
            headers: { "Content-Type": "application/json" },
            data: {
                "iware_house_id": localStorage.getItem('iware_house_id'),
                "vitem_name": "",
                "dreceived_date": data?.startDate,
                "dto_date": data?.endDate
            },
        })
        return ReceiveReportListRes = res.data

    } catch (error) {
        return ReceiveReportListRes = error.response.data
    }
});

const ReceiveReportListSlice = createSlice({
    name: 'ReceiveReportList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ReceiveReportListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ReceiveReportListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ReceiveReportListSlice.reducer; 